import { render, staticRenderFns } from "./ImportarInformacionSociodemografica.vue?vue&type=template&id=74fc3294&"
import script from "./ImportarInformacionSociodemografica.vue?vue&type=script&lang=js&"
export * from "./ImportarInformacionSociodemografica.vue?vue&type=script&lang=js&"
import style0 from "./ImportarInformacionSociodemografica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports